export default {
    mnt: {
        costs (unit) {
            if (!unit.liftmanagement) {
                return null;
            }

            const contract = unit.liftmanagement.mntContract;
            if (!contract.unit) {
                return null;
            }

            return contract.unit.costs / contract.invoicesPerYear;
        }
    },

    zus: {
        costs (unit, assessment) {
            if (!unit.liftmanagement || !assessment || !assessment.type) {
                return null;
            }

            const contract =  unit.liftmanagement.zusContract.unit;
            if (!contract) {
                return null;
            }

            switch (assessment.type.id) {
                case 'MAINAUDIT'   : return contract.mainAudit;
                case 'INTERMEDIATE': return contract.intermediateAudit;
                case 'CHANGE'      : return contract.costAuditAfterChange;
                case 'REVIEW'      : return contract.auditAfterDefects;
            }

            return null;
        }
    }
}